// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2gK5x","title":"Info_title__3Y7hp","links":"Info_links__CnKqI","link":"Info_link__24PVy","logo":"Info_logo__1cH6E"};